import { QueryKeys } from '@/constants/QueryKeys';
import { Routes } from '@/constants/Routes';
import { useAuthentication } from '@/contexts/dataSync/AuthenticationContext';
import { useSnackbar } from '@/providers/GlobalSnackbarProvider';
import { UserApi } from '@/utilities/api/UserApi';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const VerifyEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const { openSnackbar } = useSnackbar();
  const { refreshUser } = useAuthentication();

  const token = searchParams.get('token');

  const { mutate: verifyEmailUpdateToken } = useMutation(
    [QueryKeys.VALIDATE_TOKEN],
    (token: string) => UserApi.verifyEmail(token),
    {
      onError: () => {
        navigate(`${Routes.LOGIN}`);
      },
      onSuccess: async () => {
        openSnackbar(t($ => $.auth.verifyEmail.success));
        await refreshUser();
        navigate(`${Routes.LOGIN}`);
      },
      retry: false,
    },
  );
  useEffect(() => {
    if (token) {
      verifyEmailUpdateToken(token);
    } else {
      navigate(Routes.LOGIN);
    }
  }, [navigate, token, verifyEmailUpdateToken]);

  return <></>;
};
